<div class="container">
  <div class="title-row">
    <h3 class="klabel-huge">Filter by Requirement</h3>
    <app-button
      [text]="'De-select all'"
      class="grey"
      (click)="clearRequirementsFilter()"
    ></app-button>
  </div>
  <div class="content">
    <div class="section">
      <h4 class="section-title">Requirement Selection</h4>

      <div class="checkbox-group">
        <div class="checkbox-item" *ngIf="requirementList.length !== 0">
          <input
            type="checkbox"
            class="kinput"
            [checked]="
              requirementList?.length === mainFilter.requirements.length &&
              requirementList.length !== 0
            "
            (change)="selectAllRequirementsFilter($event)"
            id="selectAllRequirements"
          />
          <label for="selectAllRequirements" class="checkbox-label">
            Select all requirements
            <mat-icon class="checkbox-icon" matTooltip="Select or deselect all requirements at once" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>

        <div class="checkbox-item" *ngFor="let requirement of requirementList">
          <input
            type="checkbox"
            class="kinput"
            [checked]="checkIncludesRequirement(requirement)"
            (change)="updateCheckboxFilter($event, requirement)"
            [id]="'requirement-' + requirement?.requirement"
          />
          <label [for]="'requirement-' + requirement?.requirement" class="checkbox-label">
            {{ requirement?.requirement }}
            <mat-icon class="checkbox-icon" [matTooltip]="getRequirementHelpText(requirement)" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
